import { AppThunk } from 'store';

import { clearPopupStorageQueue } from 'contexts/PopupContext';

import { AuthApi } from 'api/AuthApi';
import { setCsrfToken } from 'store/common/commonSlice';
import { reset } from 'store/finder/thunks';

import {
  authFailed,
  authStart,
  authSuccess,
  setAuthenticated,
  setIsBanned,
  setUser,
} from './authSlice';

interface LoginPayload {
  payload: { email: string; password: string };
  headers: { csrfToken: string | null };
}

export const login =
  ({ payload, headers }: LoginPayload): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(authStart());
      const user = await AuthApi.login(payload, headers);
      dispatch(authSuccess(user));
      dispatch(setAuthenticated(true));
    } catch (err) {
      dispatch(authFailed());

      throw err;
    }
  };

export const logout = (): AppThunk => async (dispatch, getState) => {
  const state = getState();

  clearPopupStorageQueue();
  if (!state.auth.isBanned) await AuthApi.logout();
  dispatch(setUser(null));
  dispatch(setAuthenticated(false));
  dispatch(reset());

  if (!state.auth.isBanned) {
    const { csrf_token } = await AuthApi.landingInit();
    dispatch(setCsrfToken(csrf_token));
  }

  dispatch(setIsBanned(false));
};
